import { PayloadAction } from "@reduxjs/toolkit";
import { ServiceState } from "../../models/ServiceState";
import { ChangeServiceActivityPayload } from "../../payload/ChangeServiceActivity/ChangeServiceActivityPayload";

const changeServiceActivityFetch = (state: ServiceState, action: PayloadAction<ChangeServiceActivityPayload>) => {
    state.isLoading = true;
}

export default changeServiceActivityFetch;